import {
  NavigateOptions,
  To,
  useLocation,
  useNavigate as useNavigateBase,
  useOutletContext,
} from "react-router-dom";
import { Map } from "leaflet";

export function useNavigate() {
  const location = useLocation();
  const navigateBase = useNavigateBase();
  function navigate(to: To, options?: NavigateOptions) {
    const newLocation =
      typeof to === "string"
        ? { ...location, pathname: to }
        : { ...location, ...to };
    return navigateBase(newLocation, options);
  }

  return navigate;
}

interface LayoutContext {
  mapRef: Map;
  footerRef: HTMLDivElement;
  mapOverlayContainer: HTMLDivElement;
}

interface UuidContext {
  uuid: string;
}

interface UuidLayoutContext extends LayoutContext {
  uuid: string;
}

interface UuidProgressContext extends UuidContext {
  progressId: number;
}

export function useLayoutContext() {
  return useOutletContext<LayoutContext>();
}

export const useUuidContext = () => {
  return useOutletContext<UuidContext>();
};

export const useUuidLayoutContext = () => {
  return useOutletContext<UuidLayoutContext>();
};

export const useUuidProgressIdContext = () => {
  return useOutletContext<UuidProgressContext>();
};
